import PaymentSLip from '../../../../api/student/paymentslips/paymentSlip';
import fileDownload from 'js-file-download'

const paymentSLip = new PaymentSLip();

const paymentSlipModule = {
    namespaced: true,
    state: {
        item: {},
        dashboard: {},
        items: [],
        total: null,
        lookups: null,
        options: null,
        load: false,
        courses: [],
        student: null,
        isEditMode: false,
        editModePage: null,
        terms_grades:null,
    },
    getters: {
        items(state) {
            return state.items;
        },
        item(state) {
            return state.item;
        },
        load(state) {
            return state.load;
        },
        total(state) {
            return state.total;
        },
        lookups(state) {
            return state.lookups;
        },
        options: state => state.options,
        terms_grades:state=>state.terms_grades
    },
    mutations: {
        SET_ITEMS: (state, users) => {
            state.items = users;
        },
        SET_TOTAL_ITEMS: (state, total) => {
            state.total = total;
        },
        SET_ITEM: (state, item) => {
            state.item = item
        },
        SET_LOOKUPS(state, lookups) {
            state.lookups = lookups;
        },
        SET_OPTIONS(state, data) {
            state.options = data;
        },
        SET_ITEMS_LOAD: (state, load) => {
            state.load = load;
        },
    },
    actions: {
        students({commit}, payload) {
            return new Promise((resolve, reject) => {
                commit('app/SET_GENERAL_LOAD', {link:'payments/payment-slip',data:true},{root:true});
                paymentSLip.list(payload.query).then(response => {
                    commit('SET_ITEMS', response.data);
                    commit('SET_TOTAL_ITEMS', response.meta.count);
                    commit('app/SET_GENERAL_TOTAL', {link:'payments/payment-slip',data:response.meta.count},{root:true});
                    commit('app/SET_GENERAL_LOAD', {link:'payments/payment-slip',data:false},{root:true});
                    resolve(response);
                }).catch(error => {
                    commit('app/SET_GENERAL_LOAD', {link:'payments/payment-slip',data:false},{root:true});
                    reject(error);
                });
            });
        },
        printPaymentSlip({commit}, id) {
            commit('app/UPDATE_LOAD', true, {root: true});
            return new Promise((resolve, reject) => {
                paymentSLip.printPaymentSlip(id).then(response => {
                    commit('app/UPDATE_LOAD', false, {root: true});
                    
                    resolve(response);
                }).catch(error => {
                    commit('app/UPDATE_LOAD', false, {root: true});
                    reject(error);
                });
            });
        },
        get({commit}, id) {
            return new Promise((resolve, reject) => {
                commit('SET_ITEMS_LOAD', true);
                paymentSLip.get(id).then(response => {
                    commit('SET_ITEM', response.data);
                    commit('SET_ITEMS_LOAD', false);
                    resolve();
                })
            });
        },
    }
};

export default paymentSlipModule;